import React from 'react';
import { Form, Input, Tabs } from 'antd';
import InventoryManagerContainer from '../../components/sheet/InventoryManagerContainer';
import FeatureManager from '../../components/sheet/FeatureManager';
import SpellManagerContainer from '../../components/sheet/SpellManagerContainer';
import type { PartyInventory, PartyFeature, PartySpell } from '../../types/types';

interface CharacterSheetTabsProps {
  inventory: PartyInventory[];
  setInventory: React.Dispatch<React.SetStateAction<PartyInventory[]>>;
  features: PartyFeature[];
  setFeatures: React.Dispatch<React.SetStateAction<PartyFeature[]>>;
  spells: PartySpell[];
  setSpells: React.Dispatch<React.SetStateAction<PartySpell[]>>;
}

const CharacterSheetTabs: React.FC<CharacterSheetTabsProps> = ({ inventory, setInventory, features, setFeatures, spells, setSpells }) => {
  const tabItems = [
    {
      key: 'notes',
      label: 'Notes',
      children: (
        <Form.Item name="notes" noStyle>
          <Input.TextArea style={{ height: '100%', resize: 'none' }} />
        </Form.Item>
      ),
    },
    {
      key: 'inventory',
      label: 'Inventory',
      children: <InventoryManagerContainer items={inventory} onChange={setInventory} />,
    },
    {
      key: 'features',
      label: 'Features',
      children: <FeatureManager items={features} onChange={setFeatures} />,
    },
    {
      key: 'spells',
      label: 'Spells',
      children: <SpellManagerContainer items={spells} onChange={setSpells} />,
    },
  ];

  return <Tabs defaultActiveKey="notes" items={tabItems} style={{ height: '100%', display: 'flex', flexDirection: 'column' }} />;
};

export default CharacterSheetTabs;